import useEntryPoint from './useEntryPoint';

export default useEntryPoint;
